// if (document.querySelector('.wpcf7')) {
//     var form = document.querySelector('.wpcf7');
//     var href = document.querySelector('.contactSection').getAttribute('data-href')
//     form.addEventListener('wpcf7mailsent ', () => {
//         window.location.href = href;
//     });
//     $("textarea").each(function () {
//         this.setAttribute("style", "height:" + (this.scrollHeight) + "px;overflow-y:hidden;");
//       }).on("input", function () {
//         this.style.height = "auto";
//         this.style.height = (this.scrollHeight) + "px";
//       });
// }